// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".test-bundle__icon{width:40px;height:40px}@media(min-width:768px)and (max-width:991px){.test-bundle__icon{width:35px;height:35px}}@media(min-width:0)and (max-width:767px){.test-bundle__icon{width:30px;height:30px}}@media(min-width:0)and (max-width:767px){.test-bundle__arrow{width:16px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
